import { render, staticRenderFns } from "./jianzhuHintDialog.vue?vue&type=template&id=f38939e8&scoped=true&"
import script from "./jianzhuHintDialog.vue?vue&type=script&lang=js&"
export * from "./jianzhuHintDialog.vue?vue&type=script&lang=js&"
import style0 from "./jianzhuHintDialog.vue?vue&type=style&index=0&id=f38939e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38939e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f38939e8')) {
      api.createRecord('f38939e8', component.options)
    } else {
      api.reload('f38939e8', component.options)
    }
    module.hot.accept("./jianzhuHintDialog.vue?vue&type=template&id=f38939e8&scoped=true&", function () {
      api.rerender('f38939e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "meibao-insure/src/components/dialog/jianzhuHintDialog.vue"
export default component.exports